import { z } from 'zod';
import { LOCALES, PAGINATION } from '../constants/index.js';
export const uuidSchema = z.string().uuid();
export const localeSchema = z.enum(LOCALES);
/** Monetary / quantity values travel as strings so no precision is lost in JSON. */
export const decimalStringSchema = z
    .string()
    .regex(/^-?\d+(\.\d+)?$/, { message: 'validation.decimal' });
export const positiveDecimalStringSchema = decimalStringSchema.refine((v) => Number.parseFloat(v) > 0, { message: 'validation.positive' });
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce
        .number()
        .int()
        .min(1)
        .max(PAGINATION.maxPageSize)
        .default(PAGINATION.defaultPageSize),
    search: z.string().trim().min(1).max(200).optional(),
    sortBy: z.string().trim().max(50).optional(),
    sortDir: z.enum(['asc', 'desc']).default('asc'),
});
/** WGS84 point. Stored as `geography(Point, 4326)`. */
export const latLngSchema = z.object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
});
export const dateOnlySchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, {
    message: 'validation.date',
});
//# sourceMappingURL=common.js.map